import css from "./SuporteIA.module.css";

/** Card do caso aberto na Área do Cliente: número, título e link para acompanhar. */
export default function CardDoChamado({ card }) {
  return (
    <div className={css.cardChamado}>
      <span className={css.cardChamadoRotulo}>Caso #{card.codigo}</span>
      {card.titulo && <span className={css.cardChamadoTitulo}>{card.titulo}</span>}
      {card.href && (
        <a href={card.href} target="_blank" rel="noopener noreferrer" className={css.botaoNaBolha}>
          Acompanhar na Área do Cliente
        </a>
      )}
    </div>
  );
}

